module Meevo.Plugins.YieldManagementProgram {

    import Utilities = Meevo.Components.Common.Utilities;

    class ExcludedDatesComponent implements ng.IComponentController {
        minDate?: Date;
        maxDate?: Date;
        date: Date;
        model: ng.INgModelController;
        disabled: boolean;

        static $inject = [
            '$scope'
        ];

        constructor(private $scope: ng.IScope) {
        }


        $onInit() {
            this.disabled = Utilities.defaultIfNothing(this.disabled, false);

            this.$scope.$watch(() => this.minDate, () => this.updateValidation());
            this.$scope.$watch(() => this.maxDate, () => this.updateValidation());
        }

        excludeSelectedDate() {
            this.model.$viewValue.push(this.date);
            this.date = null;
            this.updateValidation();
        }

        removeExcludedDate(date) {
            if (this.disabled) return;

            this.model.$viewValue.splice(this.model.$viewValue.indexOf(date), 1);
            this.updateValidation();
        }

        updateValidation() {
            this.model.$setValidity('validRange', (() => {
                if (!this.minDate) return true;

                const viewValue = this.model.$viewValue;

                for (const excludedDate of viewValue) {
                    if (!this.dateIsValid(excludedDate)) return false;
                }

                return true;
            })());
        }

        dateFilter = (date: Date) => {
            return date.getDate() !== new Date().getDate();
        }

        dateIsValid(excludedDate: Date) {
            if (!this.minDate) return true;

            if (excludedDate < this.minDate) return false;
            else if (this.maxDate && excludedDate > this.maxDate) return false;
            else return true;
        }
    }


    angular.module('meevo.plugins.yieldManagementProgram')
        .component('excludedDates', {
            templateUrl: 'app/plugins/yieldManagementProgram/components/excluded-dates/excluded-dates.component.html',
            require: {
                model: 'ngModel'
            },
            bindings: {
                minDate: '=',
                maxDate: '=?',
                disabled: '=?',
            },
            controller: ExcludedDatesComponent
        });
}
